export const frResults = "frResults";
export const comments = "comments";
export const verifications = "verifications";
export const measuredTemperature = "measuredTemperature";
